import axios from "axios";
import { EProductStatus } from "@/assets/status";

const url = process.env.VUE_APP_XMARTSHELF_ADMINISTRATION;

const state = {
  selectedProducts: null,
  selectedProductFilterStatus: "all",
  productToUpdate: null,
  productsFilterOptions: [
    {
      value: "all",
      text: "Todos os produtos"
    },
    {
      value: "pending",
      text: "Em separação"
    },
    {
      value: "out_delivery",
      text: "Saiu para entrega"
    },
    {
      value: "waiting_withdraw",
      text: "Aguardando retirada"
    },
    {
      value: "done",
      text: "Retirados"
    },
    {
      value: "canceled",
      text: "Cancelados"
    }
  ]
};
const getters = {
  allSaleProducts(state, getters) {
    return getters.getSelectedSale.products;
  },
  allFilterSaleProducts(state, getters) {
    const products = getters.allSaleProducts.filter((product) => {
      switch (getters.selectedProductFilterStatus) {
        case "all":
          return true;
        case "pending":
          return product.status === EProductStatus.PREPARING_DELIVERY;
        case "out_delivery":
          return product.status === EProductStatus.OUT_DELIVERY;
        case "waiting_withdraw":
          return product.status === EProductStatus.WAITING_WITHDRAWAL;
        case "done":
          return (
            product.status === EProductStatus.DELIVERY_MADE ||
            product.status === EProductStatus.STORE_PICKUP
          );
        case "canceled":
          return (
            product.status === EProductStatus.PRODUCT_CANCELED ||
            product.status === EProductStatus.PRODUCT_CANCELED
          );
        default:
          return false;
      }
    });

    products.map((product) => {
      if (
        [
          EProductStatus.PREPARING_DELIVERY,
          EProductStatus.OUT_DELIVERY,
          EProductStatus.WAITING_WITHDRAWAL
        ].includes(product.status)
      ) {
        product.selectable = true;
      } else {
        product.selectable = false;
      }
    });

    products.sort((a, b) => {
      if (a.product_info.full_name < b.product_info.full_name) {
        return -1;
      }
      if (a.product_info.full_name > b.product_info.full_name) {
        return 1;
      }
      return 0;
    });

    return products;
  },
  getSelectedProducts(state) {
    return state.selectedProducts;
  },
  selectedProductFilterStatus(state) {
    return state.selectedProductFilterStatus;
  },
  productToUpdate(state) {
    return state.productToUpdate;
  },
  allProductFilterOptions(state, getters) {
    const statusMap = {
      11: "pending",
      12: "out_delivery",
      13: "waiting_withdraw",
      19: "done",
      8: "canceled"
    };
    const products = getters.allSaleProducts;
    const productStatuses = new Set(products.map((p) => p.status));
    return state.productsFilterOptions.filter(
      (option) =>
        option.value === "all" ||
        Object.entries(statusMap).some(
          ([status, value]) =>
            productStatuses.has(Number(status)) && option.value === value
        )
    );
  },
  selectableProducts(state, getters) {
    return getters.allFilterSaleProducts.filter(
      (product) => product.selectable
    );
  },
  allProductsSelected(state, getters) {
    if (!getters.getSelectedProducts) return false;
    return (
      getters.getSelectedProducts.length === getters.selectableProducts.length
    );
  },
  productsFilterStatus(state, getters) {
    switch (getters.selectedProductFilterStatus) {
      case "pending":
        return [EProductStatus.PREPARING_DELIVERY];
      case "out_delivery":
        return [EProductStatus.OUT_DELIVERY];
      case "waiting_withdraw":
        return [EProductStatus.WAITING_WITHDRAWAL];
      case "done":
        return [EProductStatus.DELIVERY_MADE, EProductStatus.STORE_PICKUP];
      case "canceled":
        return [EProductStatus.PRODUCT_CANCELED];
      default:
        return [];
    }
  },
  nextSaleProductBatchStatus(state, getters) {
    const storePick =
      getters.getSelectedSale?.delivery_details?.delivery_type ===
      "store_pickup";

    switch (getters.getSelectedProducts[0].status) {
      case EProductStatus.PREPARING_DELIVERY: // Em preparação -> Saiu para entrega ou Aguardando retirada
        return {
          newStatus: storePick
            ? EProductStatus.WAITING_WITHDRAWAL
            : EProductStatus.OUT_DELIVERY,
          variant: "delivery"
        };
      case EProductStatus.WAITING_WITHDRAWAL: // Esperando retirada -> Produto retirado na loja
        return {
          newStatus: EProductStatus.DELIVERY_MADE,
          variant: "delivery"
        };
      case EProductStatus.WAITING_REFUND_PAYMENT: // Aguardando estorno -> Estorno realizado
        return {
          newStatus: EProductStatus.PAYMENT_REFUNDED,
          variant: "payment"
        };
      default: // Qualquer outro status -> Entrega realizada
        return {
          newStatus: EProductStatus.DELIVERY_MADE,
          variant: "delivery"
        };
    }
  },
  showSaleProductStatusButton(state, getters) {
    const selectedProducts = getters.getSelectedProducts;

    if (!selectedProducts || selectedProducts?.length === 0) {
      return false;
    } else {
      const status = selectedProducts[0].status;

      return selectedProducts.every((item) => item.status === status);
    }
  },
  showSaleProductCancelButton(state, getters) {
    const selectedProducts = getters.getSelectedProducts;

    if (!selectedProducts || selectedProducts?.length === 0) return false;
    else
      return selectedProducts.every(
        (item) => item.status === EProductStatus.PREPARING_DELIVERY
      );
  }
};
const mutations = {
  setSelectedProducts(state, payload) {
    state.selectedProducts = payload;
  },
  setProductFilterStatus(state, status) {
    state.selectedProductFilterStatus = status;
  },
  setProductToUpdate(state, payload) {
    state.productToUpdate = payload;
  },
  setProductsFilterOptions({ getters }) {
    const pending = getters.allFilterSaleProducts?.some(
      (product) => product.status === EProductStatus.PREPARING_DELIVERY
    );
    const out_delivery = getters.allFilterSaleProducts?.some(
      (product) => product.status === EProductStatus.OUT_DELIVERY
    );
    const waiting_withdraw = getters.allFilterSaleProducts?.some(
      (product) => product.status === EProductStatus.WAITING_WITHDRAWAL
    );
    const done = getters.allFilterSaleProducts?.some(
      (product) =>
        product.status === EProductStatus.DELIVERY_MADE ||
        product.status === EProductStatus.STORE_PICKUP
    );

    const canceled = getters.allFilterSaleProducts?.some(
      (product) => product.status === EProductStatus.PRODUCT_CANCELED
    );

    getters.allProductFilterOptions[1].show = pending;
    getters.allProductFilterOptions[2].show = out_delivery;
    getters.allProductFilterOptions[3].show = waiting_withdraw;
    getters.allProductFilterOptions[4].show = done;
    getters.allProductFilterOptions[5].show = canceled;
  }
};
const actions = {
  setUpdateProductData({ commit, getters }, { productData, cancel = false }) {
    return new Promise((resolve) => {
      if (!productData) {
        const selectedProducts = getters.getSelectedProducts;

        if (selectedProducts?.length === 0) return null;

        const data = {
          id: selectedProducts.map((product) => product.id),
          oldStatus: selectedProducts[0].status,
          newStatus: cancel
            ? EProductStatus.PRODUCT_CANCELED
            : getters.nextSaleProductBatchStatus.newStatus,
          variant: cancel
            ? "status"
            : getters.nextSaleProductBatchStatus.variant,
          cancel: cancel
        };

        commit("setProductToUpdate", data);
      } else {
        commit("setProductToUpdate", productData);
      }

      resolve();
    });
  },
  updateProductStatus({ dispatch, commit, getters }) {
    return new Promise((resolve) => {
      const productsData = getters.productToUpdate;
      axios
        .put(
          `${url}/store/sale_product/update_status`,
          {
            sale_product_id: productsData.id,
            status: productsData.newStatus,
            user_id: getters.getUserData.id
          },
          {
            headers: {
              Authorization: `Bearer ${getters.getSessionToken}`,
              Accept: "application/json",
              "Content-Type": "application/json"
            }
          }
        )
        .then(() => {
          dispatch("loadSale", getters.getSelectedSale.id);
          commit("setSelectedProducts", null);
          commit("setProductToUpdate", null);
          resolve({
            success: true,
            message: "Produto atualizado com sucesso!"
          });
        })
        .catch((error) => {
          console.log(error);
          resolve({
            success: false,
            message: "Falha ao atualizar o produto."
          });
        });
    });
  },
  cancelProduct({ dispatch, commit, getters }) {
    return new Promise((resolve) => {
      const productsData = getters.productToUpdate;
      axios
        .put(
          `${url}/store/sale_product/cancel`,
          {
            sale_product_id: productsData.id,
            status: productsData.newStatus,
            user_id: getters.getUserData.id
          },
          {
            headers: {
              Authorization: `Bearer ${getters.getSessionToken}`,
              Accept: "application/json",
              "Content-Type": "application/json"
            }
          }
        )
        .then(() => {
          dispatch("loadSale", getters.getSelectedSale.id);
          commit("setSelectedProducts", null);
          commit("setProductToUpdate", null);
          resolve({
            success: true,
            message: "Produto cancelado com sucesso!"
          });
        })
        .catch((error) => {
          console.log(error);
          resolve({
            success: false,
            message: "Falha ao cancelar o produto."
          });
        });
    });
  },
  selectAllProducts({ commit, getters }) {
    if (getters.allProductsSelected) {
      commit("setSelectedProducts", null);
    } else {
      commit("setSelectedProducts", getters.selectableProducts);
    }
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
